const localServer = false

const ROOT_URL =
  localServer && process.env.NODE_ENV !== 'production'
    ? 'http://localhost:3000'
    : process.env.VUE_APP_BE_BASE_URL

const GRANT_TYPE = {
  password: 'password',
  refresh_token: 'refresh_token',
}
const ENTRY_POINTS = {
  people: 'people',
  circuits: 'circuits',
}

export {
  ROOT_URL, ENTRY_POINTS, GRANT_TYPE 
}
